exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ta[data-v-2fdaebc9]{display:inline-block;height:40px;width:calc(100% - 130px);margin-bottom:0;border-radius:0}.focused.ta[data-v-2fdaebc9]{height:80px}@media screen and (min-width:767px){.focused.ta[data-v-2fdaebc9],.ta[data-v-2fdaebc9]{height:40px}}", ""]);

// exports
